// extracted by mini-css-extract-plugin
export default {"card":"R6-z"};